import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const RailwayRepository = RepositoryFactory.get('RailwayRepository')['RailwayRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(RailwayRepository)

export const STORE_MODULE_NAME = 'railway';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
